import React, { useEffect, useRef } from 'react';

const CustomCursor = () => {
    const canvasRef = useRef(null);
    const points = useRef([]);
    const MAX_POINTS = 100; // Increased to allow a longer-lasting trail

    useEffect(() => {
        const canvas = canvasRef.current;
        if (!canvas) return;
        const ctx = canvas.getContext('2d');
        
        const resizeCanvas = () => {
            canvas.width = window.innerWidth;
            canvas.height = window.innerHeight;
        };

        window.addEventListener('resize', resizeCanvas);
        resizeCanvas();

        const moveCursor = (e) => {
            const { clientX: x, clientY: y } = e;
            
            // Add point immediately on move
            points.current.push({ x, y, time: Date.now() });
            
            if (points.current.length > MAX_POINTS) {
                points.current.shift();
            }
        };

        const render = () => {
            ctx.clearRect(0, 0, canvas.width, canvas.height);
            
            const now = Date.now();
            // Filter points older than 1200ms to slow down the "fade" speed
            points.current = points.current.filter(p => now - p.time < 1200);

            // Draw the tapered, curved trail
            if (points.current.length > 3) {
                for (let i = 1; i < points.current.length - 1; i++) {
                    const p1 = points.current[i];
                    const p2 = points.current[i + 1];
                    
                    const ratio = i / (points.current.length - 1);
                    const width = ratio * 5; 
                    const opacity = ratio * 0.9;
                    
                    ctx.beginPath();
                    ctx.moveTo(points.current[i-1].x, points.current[i-1].y);
                    
                    const xc = (p1.x + p2.x) / 2;
                    const yc = (p1.y + p2.y) / 2;
                    ctx.quadraticCurveTo(p1.x, p1.y, xc, yc);
                    
                    ctx.strokeStyle = '#f04e23'; 
                    ctx.lineWidth = width;
                    ctx.lineCap = 'round';
                    ctx.lineJoin = 'round';
                    ctx.globalAlpha = opacity;
                    
                    ctx.shadowBlur = ratio * 6;
                    ctx.shadowColor = '#f04e23';
                    
                    ctx.stroke();
                }
                ctx.globalAlpha = 1.0;
                ctx.shadowBlur = 0;
            }

            requestAnimationFrame(render);
        };

        const animationId = requestAnimationFrame(render);
        window.addEventListener('mousemove', moveCursor);

        return () => {
            window.removeEventListener('resize', resizeCanvas);
            window.removeEventListener('mousemove', moveCursor);
            cancelAnimationFrame(animationId);
        };
    }, []);

    return (
        <canvas 
            ref={canvasRef} 
            className="fixed top-0 left-0 w-full h-full pointer-events-none z-[999999]"
            style={{ background: 'transparent' }}
        />
    );
};

export default CustomCursor;






